import { useContext } from 'react';
import { TimeZoneContext } from './timezone-context';
export default function useTimeZoneContext() {
    return useContext(TimeZoneContext);
}
